import { RestError } from '@azure/core-http';
import { useState } from 'react';
import { useQueryGetDeliveryContainer } from '../../../hubs.queries';
import { useMutationRemoveReservationForParty } from '../../../lockers.queries';

export interface UnreserveContainerActionProps {
  deliveryContainerID: string;
  projectID: string;
  onAbort(): void;
  onSuccess(): void;
}

export function useUnreserveContainerAction({
  deliveryContainerID,
  onAbort,
  onSuccess
}: UnreserveContainerActionProps) {
  const [error, setError] = useState<RestError | undefined>(undefined);

  const container = useQueryGetDeliveryContainer(deliveryContainerID);
  const reservedForRecipients = container.data?.reservedForRecipients ?? [];

  const removeReservationMutation = useMutationRemoveReservationForParty();

  const handlers = {
    onCancelIntent() {
      onAbort();
    },
    onConfirm() {
      const partyIDs = reservedForRecipients.map((party) => party.id);
      if (partyIDs.length === 0) {
        return;
      }
      setError(undefined);
      removeReservationMutation.mutate(
        { deliveryContainerID, partyIDs },
        {
          onSuccess() {
            onSuccess();
          },
          onError(err: RestError) {
            setError(err);
          }
        }
      );
    }
  };

  return {
    container,
    reservedForRecipients,
    error,
    submitting: removeReservationMutation.isLoading,
    handlers
  } as const;
}
